import { Typography } from "@mui/material";
import type { ReactNode } from "react";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";
import type { MetaDescriptorBase } from "../../../../../../../../../api/types/svTypes.ts";
import MetaFieldItem from "../MetaFieldItem.tsx";
import { isDimensionMeta } from "../../utilities/metaUtils.ts";

interface Props<T extends MetaDescriptorBase> {
  field: T;
  caption?: string;
  actions?: ReactNode;
}

export const DimensionFieldItem = <T extends MetaDescriptorBase>({ field, caption, actions }: Props<T>) => {
  return (
    <MetaFieldItem field={field} caption={caption} actions={actions}>
      {isDimensionMeta(field) && field.isNew && (
        <Typography
          variant="caption"
          sx={(theme) => ({
            lineHeight: "100%",
            color: theme.palette.info.main,
            fontWeight: 500,
            borderRadius: 16,
            backgroundColor: makeTintedBackgroundFromColor(theme, theme.palette.info.main),
            py: 0.5,
            px: 1,
          })}
        >
          New
        </Typography>
      )}
    </MetaFieldItem>
  );
};

export default DimensionFieldItem;
